import React, { useState, useEffect } from "react";
import BasicDetails from "./OnboardingDetailsbox/BasicDetails";
import AadhaarDetails from "./OnboardingDetailsbox/AadharDetails";
import AccountVerificationDetails from "./OnboardingDetailsbox/AccountVerificationDetails";
import ShopDetails from "./OnboardingDetailsbox/ShopDetails";
import UploadDocument from "./OnboardingDetailsbox/UploadDocument";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../ResuableCompoment/Button";
import { useDispatch } from "react-redux";
import { saveMerchantFormData } from "../../../Store/Slices/AuthSlice";
import PanAadhaarVerifyModal from "./OnboardingDetailsbox/PanAadhaarVerifyModal";
// import VideoUploadDocument from "./OnboardingDetailsbox/VideoUploadDocument";

const OnboardingBasicDetails = () => {

    const location = useLocation();
    const formDataFromTable = location.state?.form;


    console.log("formdataatable", formDataFromTable)
    const [formData, setFormData] = useState({
        basicDetails: {},
        aadhaarDetails: {},
        accountDetails: {},
        shopDetails: {},
        uploadDocuments: {},
        // videouploadDocuments: {},
    });

    const [currentStep, setCurrentStep] = useState(0);
    const [isBankVerified, setIsBankVerified] = useState(false);
    const [isAccountSkipped, setIsAccountSkipped] = useState(false);
    const [showPanAadhaarModal, setShowPanAadhaarModal] = useState(false);


    const steps = [
        "Basic Details",
        "Aadhaar Details",
        "Account Verification",
        "Shop Details",
        "Documents",
        // "Video Documents",
    ];


    const [sectionErrors, setSectionErrors] = useState({
        basicDetails: {},
        aadhaarDetails: {},
        accountDetails: {},
        shopDetails: {},
        uploadDocuments: {},
        // videouploadDocuments: {},
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleUpdateSectionData = (sectionName, data) => {
        setFormData((prev) => ({
            ...prev,
            [sectionName]: data,
        }));
    };

    const handleUpdateSectionErrors = (sectionName, errors) => {
        setSectionErrors((prev) => ({
            ...prev,
            [sectionName]: errors,
        }));
    };

    // const validateForm = () => {
    //     const newErrors = {};

    //     if (!formData.basicDetails.fullName || !formData.basicDetails.dob || !formData.basicDetails.fatherName || !formData.basicDetails.gender) {
    //         newErrors.basicDetails = "Please complete the Basic Details section.";
    //     }
    //     if (!formData.aadhaarDetails.state || !formData.aadhaarDetails.pincode || !formData.aadhaarDetails.landmark || !formData.aadhaarDetails.houseAddress || !formData.aadhaarDetails.district) {
    //         newErrors.aadhaarDetails = "Please complete the Aadhaar Details section.";
    //     }
    //     if (!isAccountSkipped) {
    //         if (
    //             !formData.accountDetails.accountHolderName ||
    //             !formData.accountDetails.ifscCode ||
    //             !formData.accountDetails.accountNumber ||
    //             !formData.accountDetails.bankName
    //         ) {
    //             newErrors.accountDetails =
    //                 "Please complete the Account Verification section.";
    //         }
    //     }
    //     if (!formData.shopDetails.shopName || !formData.shopDetails.pincode || !formData.shopDetails.gstNumber) {

    //         newErrors.shopDetails = "Please complete the Shop Details section.";
    //     }
    //     if (!formData.uploadDocuments.aadhaarFront || !formData.uploadDocuments.panCard) {

    //         newErrors.uploadDocuments = "Please upload all required documents.";
    //     }

    //     // if (!formData.videouploadDocuments.VideoaadhaarFront || !formData.videouploadDocuments.VideopanCard) {

    //     //     newErrors.videouploadDocuments = "Please upload all required documents.";
    //     // }

    //     for (const section in sectionErrors) {
    //         if (Object.values(sectionErrors[section]).some((err) => err)) {
    //             newErrors[section] = "Please fix errors in this section.";
    //         }
    //     }

    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };

    const validateForm = () => {
    const newErrors = {};
    
    // Destructure for cleaner access
    const { basicDetails, aadhaarDetails, accountDetails, shopDetails, uploadDocuments } = formData;

    // 🔹 STRICT REGEX VALIDATORS
    const isValidPan = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan?.toUpperCase());
    const isValidMobile = (mob) => /^[6-9]\d{9}$/.test(mob);
    const isValidAadhaar = (aadhaar) => /^\d{12}$/.test(aadhaar?.replace(/\s/g, ''));
    const isValidPincode = (pin) => /^[1-9][0-9]{5}$/.test(pin);
    const isValidIfsc = (ifsc) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc?.toUpperCase());
    // const isValidGst = (gst) => /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst?.toUpperCase());
    

    // 🔹 HELPER: Check if child components reported errors in `sectionErrors` state
    const hasChildErrors = (sectionName) => {
        return Object.values(sectionErrors[sectionName] || {}).some(err => err);
    };

    // 1. CHECK BASIC DETAILS
    if (!basicDetails.fullName?.trim()) newErrors.basicDetails = "Full Name is required.";
    else if (!basicDetails.dob) newErrors.basicDetails = "Date of Birth is required.";
    else if (!basicDetails.gender) newErrors.basicDetails = "Gender is required.";
    else if (!basicDetails.mobileNumber || !isValidMobile(basicDetails.mobileNumber)) newErrors.basicDetails = "Valid 10-digit Mobile Number is required.";
    else if (!basicDetails.panNumber || !isValidPan(basicDetails.panNumber)) newErrors.basicDetails = "Valid PAN is required.";
    else if (hasChildErrors("basicDetails")) newErrors.basicDetails = "Please resolve the errors highlighted in Basic Details.";

    // 2. CHECK AADHAAR DETAILS
    if (!aadhaarDetails.aadharNumber || !isValidAadhaar(aadhaarDetails.aadharNumber)) newErrors.aadhaarDetails = "Valid 12-digit Aadhaar Number is required.";
    else if (!aadhaarDetails.state) newErrors.aadhaarDetails = "State is required.";
    else if (!aadhaarDetails.district) newErrors.aadhaarDetails = "District is required.";
    else if (!aadhaarDetails.houseAddress?.trim()) newErrors.aadhaarDetails = "House Address is required.";
    else if (!aadhaarDetails.pincode || !isValidPincode(aadhaarDetails.pincode)) newErrors.aadhaarDetails = "Valid 6-digit Pincode is required.";
    else if (!aadhaarDetails.landmark?.trim()) newErrors.aadhaarDetails = "Landmark is required."; // 👈 NEW
    else if (hasChildErrors("aadhaarDetails")) newErrors.aadhaarDetails = "Please resolve the errors highlighted in Aadhaar Details.";

    // 3. CHECK ACCOUNT VERIFICATION
    if (!isAccountSkipped) {
        if (!accountDetails.accountHolderName?.trim()) newErrors.accountDetails = "Account Holder Name is required.";
        else if (!accountDetails.accountNumber) newErrors.accountDetails = "Account Number is required.";
        else if (!accountDetails.ifscCode || !isValidIfsc(accountDetails.ifscCode)) newErrors.accountDetails = "Valid IFSC Code is required.";
        else if (!accountDetails.bankName) newErrors.accountDetails = "Bank Name is required.";
        else if (!isBankVerified) newErrors.accountDetails = "Please verify your bank account before proceeding.";
        else if (hasChildErrors("accountDetails")) newErrors.accountDetails = "Please resolve the errors highlighted in Account Details.";
    }

    // 4. CHECK SHOP DETAILS
    if (!shopDetails.shopName?.trim()) newErrors.shopDetails = "Shop Name is required.";

    else if (!shopDetails.gstTradeName?.trim()) newErrors.shopDetails = "GST Trade Name is required.";

    else if (!shopDetails.state) newErrors.shopDetails = "State is required.";
    else if (!shopDetails.district) newErrors.shopDetails = "District is required.";
    else if (!shopDetails.pincode || !isValidPincode(shopDetails.pincode)) newErrors.shopDetails = "Valid 6-digit Pincode is required.";
    // else if (!shopDetails.gstNumber || !isValidGst(shopDetails.gstNumber)) newErrors.shopDetails = "Valid 15-character GST Number is required.";
    else if (hasChildErrors("shopDetails")) newErrors.shopDetails = "Please resolve the errors highlighted in Shop Details.";
    else if (!shopDetails.shopAddress?.trim()) newErrors.shopDetails = "Shop Address is required."; // 👈 NEW
    else if (!shopDetails.landmark?.trim()) newErrors.shopDetails = "Landmark is required."; // 👈 NEW


    // 5. CHECK UPLOAD DOCUMENTS
    // if (!uploadDocuments.aadhaarFront) newErrors.uploadDocuments = "Aadhaar Front image is required.";
    // else if (!uploadDocuments.panCard) newErrors.uploadDocuments = "PAN Card image is required.";
    // else if (hasChildErrors("uploadDocuments")) newErrors.uploadDocuments = "Please resolve the document upload errors.";

    // 5. CHECK UPLOAD DOCUMENTS
    if (!uploadDocuments.aadhaarFront) newErrors.uploadDocuments = "Aadhaar Front image is required.";
    else if (!uploadDocuments.aadhaarBack) newErrors.uploadDocuments = "Aadhaar Back image is required.";
    else if (!uploadDocuments.panCard) newErrors.uploadDocuments = "PAN Card image is required.";
    else if (!uploadDocuments.passbookOrChequeBook) newErrors.uploadDocuments = "Bank Passbook/Chequebook image is required.";
    else if (!uploadDocuments.shopPhoto) newErrors.uploadDocuments = "Shop Photo is required.";
    else if (!uploadDocuments.signaturePhoto) newErrors.uploadDocuments = "Signature Photo is required.";
    else if (!uploadDocuments.selfieWithDocuments) newErrors.uploadDocuments = "Selfie with Documents is required.";
    else if (!uploadDocuments.selfieWithSalesPerson) newErrors.uploadDocuments = "Selfie with Sales Person is required."; // 👈 ADDED
    // else if (!uploadDocuments.gstcertificate) newErrors.uploadDocuments = "GST Certificate is required."; // 👈 ADDED
    else if (hasChildErrors("uploadDocuments")) newErrors.uploadDocuments = "Please resolve the document upload errors.";

    // Set errors to state so the UI updates and shows the error messages
    setErrors(newErrors);
    
    // If the object is empty, there are no errors, so return true (valid).
    return Object.keys(newErrors).length === 0;
};

    const handleSubmit = () => {
        setIsSubmitting(true);
        if (validateForm()) {
            console.log("Form Data Submitted:", formData);
            dispatch(saveMerchantFormData(formData));
            // alert("Form submitted successfully!");
            navigate("/mappingCommission", { state: { formDataFromTable: formDataFromTable } });
        } else {
            // alert("Please fill in all required details before proceeding.");
            setIsSubmitting(false);
        }

    };

    useEffect(() => {
        if (formDataFromTable?.meta) {
            const fileMap = {
                aadhaarBack: "aadhaarBack",
                aadhaarFront: "aadhaarFront",
                panCard: "panCard",
                passbookOrChequeBook: "passbookOrChequeBook",
                selfieWithDocuments: "selfieWithDocuments",
                selfieWithSalesPerson: "selfieWithSalesPerson",
                shopPhoto: "shopPhoto",
                signaturePhoto: "signaturePhoto",
                gstcertificate: "gstcertificate",
            };

            const videoFileMap = {
                VideoaadhaarFront: "VideoaadhaarFront",
                VideoaadhaarBack: "VideoaadhaarBack",
                VideopanCard: "VideopanCard",
                VideoshopPhoto: "VideoshopPhoto",
                Biometricdevice: "Biometricdevice",
                optional1: "optional1",
                optional2: "optional2"
            };

            console.log("videoFileMap", videoFileMap);

            const uploadDocs = {};
            const videoUploadDocs = {};

            if (Array.isArray(formDataFromTable?.metadata?.fileUrl)) {
                formDataFromTable?.metadata?.fileUrl?.forEach(url => {
                    const videoKey = Object.keys(videoFileMap).find(doc => url.includes(doc));
                    if (videoKey) {
                        console.log("videokry", videoKey);
                        videoUploadDocs[videoFileMap[videoKey]] = url;
                        console.log("videoooourl", url);
                        return;
                    }

                    const fileKey = Object.keys(fileMap).find(doc => url.includes(doc));
                    if (fileKey) {
                        console.log("filekey", fileKey);
                        uploadDocs[fileMap[fileKey]] = url;
                        console.log("uploaddocurl", url);
                    }
                });
            }




            // if (Array.isArray(formDataFromTable.metadata.fileUrl)) {
            //     formDataFromTable.metadata.fileUrl.forEach(url => {
            //         const key = Object.keys(fileMap).find(doc => url.includes(doc));
            //         if (key) {
            //             console.log("keyyyyy", key);
            //             uploadDocs[fileMap[key]] = url;
            //             console.log("uploaddocurl", url);
            //         }
            //     });
            // }

            // if (Array.isArray(formDataFromTable.metadata.fileUrl)) {
            //     formDataFromTable.metadata.fileUrl.forEach(url => {
            //         const key = Object.keys(videoFileMap).find(doc => url.includes(doc));
            //         if (key) {
            //             videoUploadDocs[videoFileMap[key]] = url;
            //             console.log("videoooourl", url)
            //         }
            //     });
            // }

            setFormData({
                basicDetails: {
                    fullName: formDataFromTable.meta?.fullName || "",
                    aadhaarNumber: formDataFromTable.meta?.aadharNumber || "",
                    dob: formDataFromTable.meta?.dob || "",
                    fatherName: formDataFromTable.meta?.fatherName || "",
                    gender: formDataFromTable.meta?.gender || "",
                    panNumber: formDataFromTable?.panCard || "",
                    mobileNumber: formDataFromTable?.mobileNumber || "",
                    email: formDataFromTable?.email || "",
                    role: formDataFromTable?.role || "",
                },
                aadhaarDetails: {
                    aadharNumber: formDataFromTable.meta?.aadharNumber || "",
                    state: formDataFromTable.meta?.aadharState || "",
                    pincode: formDataFromTable.meta?.aadharPinCode || "",
                    landmark: formDataFromTable.meta?.landmark || "",
                    houseAddress: formDataFromTable.meta?.aadharAddress || "",
                    district: formDataFromTable.meta?.aadharDistrict || "",
                    role: formDataFromTable?.role || "",
                },
                accountDetails: {
                    accountHolderName: formDataFromTable.meta?.accountHolderName || "",
                    ifscCode: formDataFromTable.meta?.ifscCode || "",
                    accountNumber: formDataFromTable.meta?.accountNumber || "",
                    bankName: formDataFromTable.meta?.bankName || "",
                    role: formDataFromTable?.role || "",
                },
                shopDetails: {
                    shopName: formDataFromTable.meta?.shopName || "",
                    pincode: formDataFromTable.meta?.shopPinCode || "",
                    shopAddress: formDataFromTable.meta?.shopAddress || "",
                    landmark: formDataFromTable.meta?.shopLandmark || "",
                    district: formDataFromTable.meta?.shopDistrict || "",
                    state: formDataFromTable.meta?.shopState || "",
                    gstNumber: formDataFromTable.meta?.gstNumber || "",
                    gstTradeName: formDataFromTable.meta?.gstTradeName || "",
                },
                uploadDocuments: {
                    ...uploadDocs
                },
                // videouploadDocuments: {
                //     ...videoUploadDocs
                // },
            });
        }
    }, [formDataFromTable]);

    // const validateCurrentStep = () => {
    //     let stepErrors = {};

    //     if (currentStep === 0) {
    //         if (
    //             !formData.basicDetails.panNumber ||
    //             !formData.basicDetails.dob ||
    //             !formData.basicDetails.fullName ||
    //             !formData.basicDetails.mobileNumber ||
    //             !formData.basicDetails.gender
    //         ) {
    //             stepErrors.basicDetails = "Please fill all required Basic Details OR Verify PAN.";
    //         }
    //     }

    //     if (currentStep === 1) {
    //         if (
    //             !formData.aadhaarDetails.aadharNumber ||
    //             !formData.aadhaarDetails.state ||
    //             !formData.aadhaarDetails.district ||
    //             !formData.aadhaarDetails.houseAddress ||
    //             !formData.aadhaarDetails.pincode
    //         ) {
    //             stepErrors.aadhaarDetails = "Please fill all required Aadhaar Details.";
    //         }
    //     }

    //     if (currentStep === 2) {
    //         if (isAccountSkipped) {
    //             return true;
    //         }
    //         if (
    //             !formData.accountDetails.accountHolderName ||
    //             !formData.accountDetails.accountNumber ||
    //             !formData.accountDetails.ifscCode ||
    //             !formData.accountDetails.bankName
    //         ) {
    //             stepErrors.accountDetails = "Please fill all Account Details.";
    //         } else if (!isBankVerified) {
    //             stepErrors.accountDetails =
    //                 "Please verify bank account before proceeding.";
    //         }
    //     }
    //     if (currentStep === 3) {
    //         if (
    //             !formData.shopDetails.shopName ||
    //             !formData.shopDetails.state ||
    //             !formData.shopDetails.district ||
    //             !formData.shopDetails.pincode ||
    //             !formData.shopDetails.gstNumber
    //         ) {
    //             stepErrors.shopDetails = "Please fill all Shop Details.";
    //         }
    //     }

    //     if (currentStep === 4) {
    //         if (
    //             !formData.uploadDocuments.aadhaarFront ||
    //             !formData.uploadDocuments.panCard
    //         ) {
    //             stepErrors.uploadDocuments = "Please upload required documents.";
    //         }
    //     }

    //     // if (currentStep === 5) {
    //     //     if (
    //     //         !formData.videouploadDocuments.VideoaadhaarFront ||
    //     //         !formData.videouploadDocuments.VideopanCard
    //     //     ) {
    //     //         stepErrors.videouploadDocuments = "Please upload required documents.";
    //     //     }
    //     // }


    //     setErrors(stepErrors);
    //     return Object.keys(stepErrors).length === 0;
    // };

    const validateCurrentStep = () => {
    let stepErrors = {};
    
    // Destructure for cleaner access
    const { basicDetails, aadhaarDetails, accountDetails, shopDetails, uploadDocuments } = formData;

    // 🔹 STRICT REGEX VALIDATORS
    const isValidPan = (pan) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan?.toUpperCase());
    const isValidMobile = (mob) => /^[6-9]\d{9}$/.test(mob);
    const isValidAadhaar = (aadhaar) => /^\d{12}$/.test(aadhaar?.replace(/\s/g, ''));
    const isValidPincode = (pin) => /^[1-9][0-9]{5}$/.test(pin);
    const isValidIfsc = (ifsc) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc?.toUpperCase());
    // const isValidGst = (gst) => /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gst?.toUpperCase());
    // Add this with your other regex validators
const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // 🔹 HELPER: Check if child components reported errors in `sectionErrors` state
    const hasChildErrors = (sectionName) => {
        return Object.values(sectionErrors[sectionName] || {}).some(err => err);
    };

    // STEP 0: BASIC DETAILS
    // 1. CHECK BASIC DETAILS (Step 0)
    if (currentStep === 0) { // <-- Only include this 'if' wrapper inside validateCurrentStep
        if (!basicDetails.fullName?.trim()) stepErrors.basicDetails = "Full Name is required.";
        else if (!basicDetails.fatherName?.trim()) stepErrors.basicDetails = "Father's Name is required."; // 👈 NEW
        else if (!basicDetails.dob) stepErrors.basicDetails = "Date of Birth is required.";
        else if (!basicDetails.gender) stepErrors.basicDetails = "Gender is required.";
        else if (!basicDetails.mobileNumber || !isValidMobile(basicDetails.mobileNumber)) stepErrors.basicDetails = "Valid 10-digit Mobile Number is required.";
        else if (!basicDetails.email || !isValidEmail(basicDetails.email)) stepErrors.basicDetails = "Valid Email Address is required."; // 👈 NEW
        else if (!basicDetails.panNumber || !isValidPan(basicDetails.panNumber)) stepErrors.basicDetails = "Valid PAN is required.";
        else if (hasChildErrors("basicDetails")) stepErrors.basicDetails = "Please resolve the errors highlighted in the form.";
    }

    // STEP 1: AADHAAR DETAILS
    if (currentStep === 1) {
        if (!aadhaarDetails.aadharNumber || !isValidAadhaar(aadhaarDetails.aadharNumber)) stepErrors.aadhaarDetails = "Valid 12-digit Aadhaar Number is required.";
        else if (!aadhaarDetails.state) stepErrors.aadhaarDetails = "State is required.";
        else if (!aadhaarDetails.district) stepErrors.aadhaarDetails = "District is required.";
        else if (!aadhaarDetails.houseAddress?.trim()) stepErrors.aadhaarDetails = "House Address is required.";
        else if (!aadhaarDetails.pincode || !isValidPincode(aadhaarDetails.pincode)) stepErrors.aadhaarDetails = "Valid 6-digit Pincode is required.";
        else if (!aadhaarDetails.landmark?.trim()) stepErrors.aadhaarDetails = "Landmark is required."; 
        else if (hasChildErrors("aadhaarDetails")) stepErrors.aadhaarDetails = "Please resolve the errors highlighted in the form.";
    }

    // STEP 2: ACCOUNT VERIFICATION
    if (currentStep === 2) {
        if (!isAccountSkipped) {
            if (!accountDetails.accountHolderName?.trim()) stepErrors.accountDetails = "Account Holder Name is required.";
            else if (!accountDetails.accountNumber) stepErrors.accountDetails = "Account Number is required.";
            else if (!accountDetails.ifscCode || !isValidIfsc(accountDetails.ifscCode)) stepErrors.accountDetails = "Valid IFSC Code is required.";
            else if (!accountDetails.bankName) stepErrors.accountDetails = "Bank Name is required.";
            else if (!isBankVerified) stepErrors.accountDetails = "Please verify your bank account before proceeding.";
            else if (hasChildErrors("accountDetails")) stepErrors.accountDetails = "Please resolve the errors highlighted in the form.";
        }
    }

    // STEP 3: SHOP DETAILS
    if (currentStep === 3) {
        if (!shopDetails.shopName?.trim()) stepErrors.shopDetails = "Shop Name is required.";
        else if (!shopDetails.gstTradeName?.trim()) stepErrors.shopDetails = "GST Trade Name is required.";
        else if (!shopDetails.state) stepErrors.shopDetails = "State is required.";
        else if (!shopDetails.district) stepErrors.shopDetails = "District is required.";
        else if (!shopDetails.pincode || !isValidPincode(shopDetails.pincode)) stepErrors.shopDetails = "Valid 6-digit Pincode is required.";
        // else if (!shopDetails.gstNumber || !(shopDetails.gstNumber)) stepErrors.shopDetails = "Valid 15-character GST Number is required.";
        else if (!shopDetails.shopAddress?.trim()) stepErrors.shopDetails = "Shop Address is required."; 
        else if (!shopDetails.landmark?.trim()) stepErrors.shopDetails = "Landmark is required."; 
        else if (hasChildErrors("shopDetails")) stepErrors.shopDetails = "Please resolve the errors highlighted in the form.";
    }

    // STEP 4: DOCUMENTS
    // if (currentStep === 4) {
    //     if (!uploadDocuments.aadhaarFront) stepErrors.uploadDocuments = "Aadhaar Front image is required.";
    //     else if (!uploadDocuments.panCard) stepErrors.uploadDocuments = "PAN Card image is required.";
    //     else if (hasChildErrors("uploadDocuments")) stepErrors.uploadDocuments = "Please resolve the upload errors.";
    // }

    // STEP 4: DOCUMENTS
    if (currentStep === 4) {
        if (!uploadDocuments.aadhaarFront) stepErrors.uploadDocuments = "Aadhaar Front image is required.";
        else if (!uploadDocuments.aadhaarBack) stepErrors.uploadDocuments = "Aadhaar Back image is required.";
        else if (!uploadDocuments.panCard) stepErrors.uploadDocuments = "PAN Card image is required.";
        else if (!uploadDocuments.passbookOrChequeBook) stepErrors.uploadDocuments = "Bank Passbook/Chequebook image is required.";
        else if (!uploadDocuments.shopPhoto) stepErrors.uploadDocuments = "Shop Photo is required.";
        else if (!uploadDocuments.signaturePhoto) stepErrors.uploadDocuments = "Signature Photo is required.";
        else if (!uploadDocuments.selfieWithDocuments) stepErrors.uploadDocuments = "Selfie with Documents is required.";
        else if (!uploadDocuments.selfieWithSalesPerson) stepErrors.uploadDocuments = "Selfie with Sales Person is required."; // 👈 ADDED
        // else if (!uploadDocuments.gstcertificate) stepErrors.uploadDocuments = "GST Certificate is required."; // 👈 ADDED
        else if (hasChildErrors("uploadDocuments")) stepErrors.uploadDocuments = "Please resolve the document upload errors.";
    }

    setErrors(stepErrors);
    return Object.keys(stepErrors).length === 0;
};

    return (
        <div className="h-full bg-[#EEF1F5] px-3 sm:px-6 py-3 sm:py-4">

            {showPanAadhaarModal && (
                <PanAadhaarVerifyModal
                    onClose={() => setShowPanAadhaarModal(false)}
                    onSuccess={() => {
                        setShowPanAadhaarModal(false);
                    }}
                />
            )}

            {/* Header */}
            <div className="mb-4 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                <div>
                    <h2 className="text-base sm:text-lg font-semibold text-[#0A2A4F]">
                        MERCHANT ONBOARDING
                    </h2>
                    <p className="text-xs sm:text-sm text-slate-500">
                        Fill all required details step by step
                    </p>
                </div>

                <div className="w-full sm:w-auto">
                    <Button
                        label="LINK PAN Aadhaar Check"
                        variant="outline"
                        className="w-full sm:w-auto"
                        onClick={() => setShowPanAadhaarModal(true)}
                    />
                </div>
            </div>

            {/* Stepper */}
            <div className="mb-6 overflow-x-auto">
                <div className="relative flex items-center justify-between min-w-[500px] sm:min-w-full">

                    {/* Background Line */}
                    <div className="absolute top-1/2 left-0 right-0 h-[2px] bg-gray-300 -translate-y-1/2" />

                    {/* Active Line */}
                    <div
                        className="absolute top-1/2 left-0 h-[2px] bg-[#0A2A4F] -translate-y-1/2 transition-all duration-300"
                        style={{
                            width: `${(currentStep / (steps.length - 1)) * 100}%`,
                        }}
                    />

                    {steps.map((step, index) => {
                        const isCompleted = index < currentStep;
                        const isActive = index === currentStep;

                        return (
                            <div
                                key={index}
                                className="relative z-10 flex flex-col items-center flex-1"
                            >
                                <div
                                    className={`w-7 h-7 sm:w-9 sm:h-9 flex items-center justify-center rounded-full border-2 font-semibold text-xs sm:text-sm
                ${isCompleted
                                            ? "bg-[#0A2A4F] border-[#0A2A4F] text-white"
                                            : isActive
                                                ? "bg-white border-[#0A2A4F] text-[#0A2A4F]"
                                                : "bg-white border-gray-300 text-gray-400"
                                        }`}
                                >
                                    {index + 1}
                                </div>

                                <span
                                    className={`mt-1 text-[10px] sm:text-xs text-center max-w-[70px] sm:max-w-[90px]
                ${isActive || isCompleted
                                            ? "text-[#0A2A4F] font-medium"
                                            : "text-gray-400"
                                        }`}
                                >
                                    {step}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Form Container */}
            <div className="bg-white rounded-lg sm:rounded-xl border border-gray-200 shadow-sm p-4 sm:p-8 flex flex-col">

                {/* STEP CONTENT SAME (NO CHANGE) */}

                {currentStep === 0 && (
                    <div className="flex-1">
                        <BasicDetails
                            data={formData.basicDetails}
                            onUpdate={(data) =>
                                handleUpdateSectionData("basicDetails", data)
                            }
                            onErrorUpdate={(errors) =>
                                handleUpdateSectionErrors("basicDetails", errors)
                            }
                        />
                        {errors.basicDetails && (
                            <p className="text-xs sm:text-sm text-red-600 mt-3">
                                {errors.basicDetails}
                            </p>
                        )}
                    </div>
                )}

                {currentStep === 1 && (
                    <div className="flex-1">
                        <AadhaarDetails
                            data={formData.aadhaarDetails}
                            onUpdate={(data) =>
                                handleUpdateSectionData("aadhaarDetails", data)
                            }
                            onErrorUpdate={(errors) =>
                                handleUpdateSectionErrors("aadhaarDetails", errors)
                            }
                        />
                        {errors.aadhaarDetails && (
                            <p className="text-xs sm:text-sm text-red-600 mt-3">
                                {errors.aadhaarDetails}
                            </p>
                        )}
                    </div>
                )}

                {currentStep === 2 && (
                    <div className="flex-1">
                        <AccountVerificationDetails
                            data={formData.accountDetails}
                            onUpdate={(data) =>
                                handleUpdateSectionData("accountDetails", data)
                            }
                            onBankVerified={setIsBankVerified}
                            onNext={() => {
                                setIsAccountSkipped(true);
                                setIsBankVerified(true);
                                setCurrentStep((prev) => prev + 1);
                            }}
                        />
                        {errors.accountDetails && (
                            <p className="text-xs sm:text-sm text-red-600 mt-3">
                                {errors.accountDetails}
                            </p>
                        )}
                    </div>
                )}

                {currentStep === 3 && (
                    <div className="flex-1">
                        <ShopDetails
                            data={formData.shopDetails}
                            onUpdate={(data) =>
                                handleUpdateSectionData("shopDetails", data)
                            }
                        />
                        {errors.shopDetails && (
                            <p className="text-xs sm:text-sm text-red-600 mt-3">
                                {errors.shopDetails}
                            </p>
                        )}
                    </div>
                )}

                {currentStep === 4 && (
                    <div className="flex-1">
                        <UploadDocument
                            data={formData.uploadDocuments}
                            onUpdate={(data) =>
                                handleUpdateSectionData("uploadDocuments", data)
                            }
                        />
                        {errors.uploadDocuments && (
                            <p className="text-xs sm:text-sm text-red-600 mt-3">
                                {errors.uploadDocuments}
                            </p>
                        )}
                    </div>
                )}

                {/* Footer */}
                <div className="sticky bottom-0 left-0 bg-white pt-3 pb-3 mb-10 border-t border-gray-200 flex flex-col sm:flex-row gap-3 z-20">

                    <Button
                        label="Back"
                        variant="outline"
                        className="w-full sm:w-auto"
                        disabled={currentStep === 0}
                        onClick={() => setCurrentStep((prev) => prev - 1)}
                    />

                    {currentStep < steps.length - 1 ? (
                        <Button
                            label="Next"
                            className="w-full sm:w-auto"
                            onClick={() => {
                                if (validateCurrentStep()) {
                                    setCurrentStep((prev) => prev + 1);
                                }
                            }}
                        />
                    ) : (
                        <Button
                            label={isSubmitting ? "Submitting..." : "Save and Continue"}
                            className="w-full sm:w-auto"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        />
                    )}

                </div>

            </div>
        </div>
    );


};

export default OnboardingBasicDetails;